import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Select from '../Select';

const S = {
  Select: styled(Select)`
    width: 130px;
  `,
};

/**
 * RowsPerPageFilter를 사용하여 테이블에서 한 페이지당 보여질 행의 갯수를 설정할 수 있습니다.
 *
 * @version 1.0.0
 * @author [chayeoi](https://github.com/chayeoi)
 */

const RowsPerPageFilter = ({ options, value, onChange }) => (
  <S.Select
    options={options}
    value={value}
    onChange={onChange}
  />
);

RowsPerPageFilter.propTypes = {
  /** 옵션 아이템 목록 */
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
  })).isRequired,
  /** 현재 활성화된 아이템 */
  value: PropTypes.string.isRequired,
  /** 선택된 옵션이 변경될 때 호출될 콜백 함수 */
  onChange: PropTypes.func.isRequired,
};

export default RowsPerPageFilter;
